import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocUploadComponent } from './components/doc-upload/doc-upload.component';
import { SuccessComponent } from './components/success/success.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/form-sections/form-sections.module').then((mod) => mod.FormSectionsModule)
  },
  {
    path: 'document-upload',
    component: DocUploadComponent
  },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./components/form-sections/form-login/form-login.module').then((mod) => mod.FormLoginModule)
  },
  {
    path: 'ukmortgage',
    loadChildren: () => {
      return import('./modules/ukmortgage/ukmortgage.module').then((mod) => mod.UkmortgageModule);
    }
  },
  {
    path: 'ukvoy',
    loadChildren: () => {
      return import('./modules/ukvoy/ukvoy.module').then((mod) => mod.UkvoyModule);
    }
  },
  {
    path: 'ukpba',
    loadChildren: () => {
      return import('./modules/ukpba/ukpba.module').then((mod) => mod.UkpbaModule);
    }
  },
  {
    path: 'ukcaa',
    loadChildren: () => {
      return import('./modules/ukcaa/ukcaa.module').then((mod) => mod.UkcaaModule);
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
